module.exports = __webpack_public_path__ + "static/media/freight-people-logo-white2x.e9b71261.png";